<!-- Language switcher is either in mainNavBar or inside of the threepoint -->
<ng-template #languageSwitcher let-isInThreepoint="isInThreepoint">
  <button type="button" aria-label="Change language" mat-button [matTooltip]="selText.msgChooseLang"
    matTooltipClass="tooltipStyle" [matTooltipPosition]="isInThreepoint ? 'left' : 'below'" (click)="changeLang()"
    [style.width]="isInThreepoint ? '100%' : 'initial'" [class.buttonInThreepoint]="isInThreepoint">
    <mat-icon class="mainNavBarIcons">language</mat-icon>
    <span style="font-size: 18px; color: var(--defaultIconColor);">{{lang === "is" ? "EN" : "IS"}}</span>
  </button>
</ng-template>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav-content>
    <mat-toolbar color="primary" style="background-color: var(--sys-surface-bright);">
      @if (
      selText.logoURL !== '' &&
      selText.logoURL !== '#' &&
      selText.logoURL !== null &&
      selText.logoURL !== undefined
      ) {
      <a href="{{ selText.logoURL }}" class="appLogo">
        <!-- ath url -->
        <img src="{{ selText.logo }}" alt="{{ selText.name }}" width="{{ selText.logoWidth }}"
          height="{{ selText.logoHeight }}" />
        </a>
      }
      <div id="titleBox" class="mainNavBarIcons" [style.justify-content]="
          applicationSettings?.option?.title?.position ?? 'flex-start'
        " [style.font-size]="
          applicationSettings?.option?.title?.fontSize ?? '20px'
        " [style.color]="
          applicationSettings?.option?.title?.fontColor ?? 'inherit'
        ">
        <span class="hide-on-mobile">{{ selText.name }}</span>
        @if (selText.name && selText.title) {
        <span class="hide-on-mobile">&nbsp;-&nbsp;</span>
        }
        <span class="hide-on-mobile">{{ selText.title }}</span>
        </div>

      @if (userIsCurrentlyLoggedIn) {
      <div [matMenuTriggerFor]="userMenu" id="accountInfo">
        <p id="loggedInFullName">{{ userFullName }}</p>
        <mat-icon>account_circle</mat-icon>
        <mat-icon id="accountArrow">keyboard_arrow_down</mat-icon>
      </div>
      }

      <mat-menu #userMenu="matMenu">
        <mat-list class="userActionsList">
          <mat-list-item>
            <button mat-menu-item (click)="logOut()">
              {{ selText.logout }}
            </button>
          </mat-list-item>
          @if (enableUserProfileEdit) {
          <div>
            <mat-list-item>
              <button mat-menu-item (click)="openEditUserProfile(userProfileAction.ChangePassword)">
                {{ selText.changePassword }}
              </button>
            </mat-list-item>
          </div>
          }
        </mat-list>
      </mat-menu>
      <!-- A "trick" so that it always displays the template when value arrives no matter if its true or false which this
        BehaviousSubject splitMapActive returns. Because we are only intersted in sharing the data from obs and use it in
        several places as a local variable.
        https://stackoverflow.com/questions/70939409/angular-async-pipe-in-ngif-handle-0-value
        -->
      @if ({splitMapActive: displayService.splitMapActive$ | async }; as splitMapState) {
      <div class="mainActionBarWrapper">
        <!-- Choose basemaps (on mainNavBar) -->
        @if (selText.baseMaps != null && !splitMapState.splitMapActive) {
        <button class="mainNavBarIcons" (menuClosed)="basemapsMenuClosed()" (menuOpened)="basemapsMenuOpened()" mat-icon-button
          #basemapsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="basemapCategories" [matTooltip]="selText.baseMaps"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">map</mat-icon>
        </button>
        }
        
        <mat-menu #basemapCategories [hasBackdrop]="false">
          @if (baseMapsMenuOpen) {
          <app-layer-list [mapLayers]="mapLayers"
            [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
            [layerTree]="layerService.basemapLayerTree" [splitMapActive]="displayService.splitMapActive$ | async"
            [selText]="selText" [lang]="lang" [isBasemapTree]="true" [applicationSettings]="applicationSettings"
            [mapObject]="mapObject" [isSecondaryMap]="false">
          </app-layer-list>
          }
        </mat-menu>
        <!-- Choose maps (on mainNavBar) -->

        @if (selText.maps != null && displayService.isSubAppActive && !splitMapState.splitMapActive) {
        <button class="mainNavBarIcons" (menuClosed)="mapsMenuClosed()" (menuOpened)="mapsMenuOpened()" mat-button
          #mapsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="mapCategories">
          {{ selText.maps }}
        </button>
        }
        
        <mat-menu #mapCategories [hasBackdrop]="false" xPosition="before">
          @if (mapsMenuOpen) {
          <app-layer-list [mapLayers]="mapLayers"
            [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
            [layerTree]="layerService.layerTree" [splitMapActive]="displayService.splitMapActive$ | async"
            [selText]="selText" [lang]="lang" [isBasemapTree]="false" [applicationSettings]="applicationSettings"
            [mapObject]="mapObject" [isSecondaryMap]="false">
          </app-layer-list>
          }
        </mat-menu>

        @if (switchApplicationAvailable && apps && apps.length) {
        <button aria-label="Switch view" mat-icon-button type="button" (click)="toggleSwitchApplication()"
          [matTooltip]="selText.applicationLabelText" matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">apps</mat-icon>
        </button>
        }
        @if (displayService.showLocation === true) {
        <button mat-icon-button type="button" (click)="toggleCurrentLocation()" [matTooltip]="
                    isShowingLocation
                      ? selText.turnOffLocation
                      : selText.turnOnLocation
                  " matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">{{
            isShowingLocation ? "location_off" : "location_on"
            }}</mat-icon>
        </button>
        }
        @if (displayService.mapviewInterface.canToggle === true &&
        applicationSettings?.option?.iconsInMainNavBar?.interfaceMode && !isMobileView) {
        <button mat-icon-button type="button" (click)="toggleInterface()"
          [matTooltip]="displayService.mapviewInterface.isSimple ? selText.advancedInterface : selText.simpleInterface"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons">
            {{ displayService.mapviewInterface.isSimple
            ? 'radio_button_checked'
            : 'radio_button_unchecked' }}
          </mat-icon>
        </button>
        }
        @if (selText.url && applicationSettings?.option?.iconsInMainNavBar?.url && !isMobileView) {
        <button mat-icon-button type="button" (click)="this.displayService.getCurrentLink()" [matTooltip]="selText.urlLabelText"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">link</mat-icon>
        </button>
        }
        @if (!disablePDFScreenshot && applicationSettings?.option?.iconsInMainNavBar?.screenshot && !isMobileView) {
        <button mat-icon-button type="button" (click)="downloadPDF()"
          [disabled]="isDownloadingPDF || splitMapState.splitMapActive"
          [matTooltip]="splitMapState.splitMapActive ? 'Screenshot not available in split map mode' : selText.screenshotText"
          matTooltipClass="tooltipStyle" [class.mainNavBarIconsDisabled]="isDownloadingPDF || splitMapState.splitMapActive">
          <mat-icon class="mainNavBarIcons" width="18" height="18">picture_as_pdf</mat-icon>
        </button>
        }
        @if (measureToolsAvailable && applicationSettings?.option?.iconsInMainNavBar?.measureTools && !isMobileView) {
        <button mat-icon-button type="button" (click)="activateMeasureTool()"
          [disabled]="splitMapState.splitMapActive ? true : false"
          [matTooltip]="splitMapState.splitMapActive ? 'Screenshot not available in split map mode' : selText.measure"
          matTooltipClass="tooltipStyle" [class.mainNavBarIconsDisabled]="splitMapState.splitMapActive">
          <mat-icon class="mainNavBarIcons" width="18" height="18">straighten</mat-icon>
        </button>
        }
        @if (!userIsCurrentlyLoggedIn && userLoginAvailable === true &&
        applicationSettings?.option?.iconsInMainNavBar?.login && !isMobileView) {
        <button mat-icon-button type="button" (click)="initiateLogin()" [matTooltip]="selText.login"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">login</mat-icon>
        </button>
        }
        <!--TODO: Use selText.deactivateSplitMap if splitMapActive-->
        <!--TODO: Use another icon if splitMapActive-->
        @if (applicationSettings?.option?.iconsInMainNavBar?.splitMap && displayService.enableSplitMap && !isMobileView)
        {
        <button mat-icon-button (click)="displayService.splitMapActive$.next(!displayService.splitMapActive$.value)"
          [matTooltip]="splitMapState.splitMapActive ? selText.deactivateSplitMap : selText.activateSplitMap"
          matTooltipClass="tooltipStyle">
          <mat-icon style="transform: rotate(90deg); margin-bottom: 2.5px;" class="mainNavBarIcons">splitscreen</mat-icon>
        </button>
        }
        @if (!applicationSettings?.option?.disableUserCanToggleTheme &&
        (applicationSettings?.option?.iconsInMainNavBar?.theme && !isMobileView)) {
        <button mat-icon-button (click)="toggleDarkLightMode()" [matTooltip]="selText.changeColorTheme"
          matTooltipClass="tooltipStyle" matTooltipPosition="below">
          <mat-icon class="mainNavBarIcons" width="18" height="18">{{displayService.colorTheme === 'light' ? 'dark_mode'
            : 'light_mode'}}</mat-icon>
        </button>
        }
        @if (applicationSettings?.option?.iconsInMainNavBar?.about && displayService.hideAbout === false &&
        !isMobileView) {
        <button mat-icon-button type="button" (click)="toggleAbout()" [matTooltip]="selText.about"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">info</mat-icon>
        </button>
        }
        <!--
        <button mat-icon-button type="button" (click)="toggle3D()" matTooltip="Skipta 3D"
          matTooltipClass="tooltipStyle">
          <mat-icon class="mainNavBarIcons" width="18" height="18">3d</mat-icon>
        </button>
        -->
        <!-- Change Language -->
        @if (applicationSettings?.option?.iconsInMainNavBar?.language && !isMobileView) {
        <ng-container *ngTemplateOutlet="languageSwitcher"></ng-container>
        }
        <!-- More options -->
        @if (selText.moreOptions && threePointHasContent) {
        <button [matTooltip]="selText.moreOptions" matTooltipClass="tooltipStyle" type="button" mat-icon-button
          [matMenuTriggerFor]="mainSubMenu" #threepointsMenuTrigger="matMenuTrigger">
          <mat-icon class="mainNavBarIcons">more_vert</mat-icon>
        </button>
        }
        
        <!--  Above here: Items on the main navbar (not inside threePoint)
            ------------------------------------------------------------------------------------------------------------------------------------------------------
            Below here: Items inside of the threePoint (leita, gögn and grunnkort go inside when width of viewport is small) -->
        <mat-menu #mainSubMenu="matMenu" [hasBackdrop]="false" xPosition="after" class="threePointBackground">
        
          <mat-list role="list" class="threePoint">

            <!-- Choose basemaps (inside threePoint) -->
            @if (selText.baseMaps != null && displayService.isSubAppActive) {
            <mat-list-item role="listitem" class="smallMenu">
              <button mat-menu-item #threepointBasemapsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="basemapCategories"
                (menuClosed)="basemapsMenuClosed()" (menuOpened)="basemapsMenuOpened()" (click)="$event.stopPropagation()">
                {{ selText.baseMaps }}
              </button>
            </mat-list-item>
            }
            
            <!-- Choose maps (inside threePoint)-->
            
            <mat-list-item role="listitem" class="smallMenu">
              @if (selText.maps != null && displayService.isSubAppActive && !splitMapState.splitMapActive) {
              <button (menuClosed)="mapsMenuClosed()" (menuOpened)="mapsMenuOpened()" mat-menu-item
                #threepointMapsMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="mapCategories" (click)="$event.stopPropagation()">
                {{ selText.maps }}
              </button>
              }
              </mat-list-item>
              
            <!-- Toggle interface -->
            @if (displayService.mapviewInterface.canToggle === true &&
            (!applicationSettings?.option?.iconsInMainNavBar?.interfaceMode || isMobileView)) {
            <mat-list-item>
              <button mat-menu-item class="buttonInThreepoint" (click)="toggleInterface()"
                matTooltip="{{displayService.mapviewInterface.isSimple ? selText.advancedInterface : selText.simpleInterface}}"
                matTooltipClass="tooltipStyle" matTooltipPosition="left" aria-label="Interface">
                <mat-icon class="moreMatIcon">
                  {{
                  displayService.mapviewInterface.isSimple
                  ? "radio_button_checked"
                  : "radio_button_unchecked"
                  }}
                </mat-icon>
              </button>
            </mat-list-item>
            }
            <!-- Generate URL -->
            @if (selText.url && (!applicationSettings?.option?.iconsInMainNavBar?.url || isMobileView)) {
            <mat-list-item role="listitem" matTooltip="{{ selText.urlLabelText }}" matTooltipClass="tooltipStyle"
              matTooltipPosition="left">
              <button mat-menu-item class="buttonInThreepoint" (click)="this.displayService.getCurrentLink()"
                aria-label="Generate URL">
                <mat-icon class="moreMatIcon">link</mat-icon>
              </button>
            </mat-list-item>
            }
            <!-- Take screenshot of map -->
            @if (!disablePDFScreenshot && (!applicationSettings?.option?.iconsInMainNavBar?.screenshot || isMobileView))
            {
            <mat-list-item role="listitem" matTooltipClass="tooltipStyle" [matTooltip]="
                                                          splitMapState.splitMapActive
                                                            ? 'Screenshot not available in split map mode'
                                                            : selText.screenshotText
                                " matTooltipPosition="left">
              <button mat-menu-item class="buttonInThreepoint" (click)="downloadPDF()"
                [disabled]="isDownloadingPDF || splitMapState.splitMapActive" aria-label="Screenshot">
                <mat-icon class="moreMatIcon">picture_as_pdf</mat-icon>
              </button>
            </mat-list-item>
            }

            <!-- Open measure tools -->
            @if (measureToolsAvailable && (!applicationSettings?.option?.iconsInMainNavBar?.measureTools ||
            isMobileView)) {
            <mat-list-item role="listitem" [title]="
                        splitMapState.splitMapActive
                          ? 'Measuring tools not available in split map mode'
                          : ''
                      ">
              <button mat-menu-item class="buttonInThreepoint" [disabled]="splitMapState.splitMapActive ? true : false"
                aria-label="Measure" (click)="activateMeasureTool()" matTooltip="{{ selText.measure }}"
                matTooltipClass="tooltipStyle" matTooltipPosition="left">
                <mat-icon id="measureIcon" class="moreMatIcon">straighten</mat-icon>
              </button>
            </mat-list-item>
            }
            <!-- Login -->
            @if (!userIsCurrentlyLoggedIn && userLoginAvailable === true &&
            (!applicationSettings?.option?.iconsInMainNavBar?.login || isMobileView)) {
            <mat-list-item>
              <button mat-menu-item class="buttonInThreepoint" id="loginButton" (click)="initiateLogin()" aria-label="Login"
                matTooltip="{{ selText.login }}" matTooltipClass="tooltipStyle" matTooltipPosition="left">
                <mat-icon id="loginIcon" class="moreMatIcon">login</mat-icon>
              </button>
            </mat-list-item>
            }
            <!-- Activate split map from main-nav.component -->
            @if (displayService.enableSplitMap && (!applicationSettings?.option?.iconsInMainNavBar?.splitMap ||
            isMobileView)) {
            <mat-list-item>
              <button mat-menu-item class="buttonInThreepoint"
                (click)="displayService.splitMapActive$.next(!displayService.splitMapActive$.value)"
                [matTooltip]="splitMapState.splitMapActive ? selText.deactivateSplitMap : selText.activateSplitMap"
                matTooltipClass="tooltipStyle" matTooltipPosition="left">
                <mat-icon style="transform: rotate(90deg);" class="moreMatIcon">splitscreen</mat-icon>
              </button>
              </mat-list-item>
              }
            @if (!applicationSettings?.option?.disableUserCanToggleTheme &&
            (!applicationSettings?.option?.iconsInMainNavBar?.theme || isMobileView)) {
            <mat-list-item>
              <button mat-menu-item class="buttonInThreepoint" (click)="toggleDarkLightMode()"
                [matTooltip]="selText.changeColorTheme" matTooltipClass="tooltipStyle" matTooltipPosition="left" aria-label="Theme">
                <mat-icon class="moreMatIcon">{{displayService.colorTheme === 'light' ? 'dark_mode' :
                  'light_mode'}}</mat-icon>
              </button>
            </mat-list-item>
            }
            @if (displayService.hideAbout === false && (!applicationSettings?.option?.iconsInMainNavBar?.about ||
            isMobileView)) {
            <mat-list-item>
              <button mat-menu-item class="buttonInThreepoint" (click)="toggleAbout()" matTooltip="{{ selText.about }}"
                matTooltipClass="tooltipStyle" matTooltipPosition="left" aria-label="About">
                <mat-icon class="moreMatIcon">info</mat-icon>
              </button>
              </mat-list-item>
              }
            <!-- Change Language -->
            @if (!applicationSettings?.option?.iconsInMainNavBar?.language || isMobileView) {
            <mat-list-item role="listitem">
              <ng-container>
                <ng-container *ngTemplateOutlet="languageSwitcher; context: {isInThreepoint: true}"></ng-container>
              </ng-container>
            </mat-list-item>
            }
          </mat-list>
          </mat-menu>
          </div>
          }
          </mat-toolbar>
          </mat-sidenav-content>
          </mat-sidenav-container>

@if (aboutOpen) {
<app-about (closeAboutee)="closeAbout()" [selText]="selText" [applicationSettings]="applicationSettings"
  [lang]="lang"></app-about>
}

@if (editUserProfileOpen) {
<app-edit-user-profile (closeEditUserProfilee)="closeEditUserProfile()" [selText]="selText"
  [applicationSettings]="applicationSettings" [lang]="lang" [editAction]="editAction"></app-edit-user-profile>
}

<div #loadingLogoContainer class="loadingLogoContainer"></div>